// src/components/patient/PatientAuthGuard.jsx

import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  getPatientAccessToken,
  isJwtExpired,
  patientLogout,
} from "../../lib/patientAuth";

const PUBLIC_PATIENT_PATHS = [
  "/patient/login",
  "/patient/register",
  "/patient/forgot-password",
  "/patient/reset-password",
  "/patient/verify-email",
];

function isPublicPatientPath(pathname) {
  return PUBLIC_PATIENT_PATHS.some((path) => pathname.startsWith(path));
}

export default function PatientAuthGuard({ children }) {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;

    if (!pathname.startsWith("/patient")) {
      return;
    }

    if (isPublicPatientPath(pathname)) {
      return;
    }

    const token = getPatientAccessToken();

    if (!token || isJwtExpired(token)) {
      patientLogout({ reason: "session_expired" });
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    const interval = window.setInterval(() => {
      const pathname = window.location.pathname;

      if (!pathname.startsWith("/patient")) {
        return;
      }

      if (isPublicPatientPath(pathname)) {
        return;
      }

      const token = getPatientAccessToken();

      if (!token || isJwtExpired(token)) {
        patientLogout({ reason: "session_expired" });
      }
    }, 30000);

    return () => window.clearInterval(interval);
  }, []);

  return children;
}